import { createContainer } from 'unstated-next'

import { useAddToBag } from './useAddToBag'

/**
 * @deprecated Use useCart, VariantSelectionForm, useCartDialog, and possible some new Embroidery utilities if
 */
export const AddToBagContainer = createContainer(useAddToBag)
